import { ProductSliderStyleTokens } from "@omni/ui/brand/product/productSlider/productSlider.tokens";
import { UIProductSlider } from "@omni/ui/components/Product/ProductSlider/productSlider.styles";
import { tv } from "tailwind-variants";

export const ProductSliderStyles: ProductSliderStyleTokens = {
    navButtonColor: "transparent"
};

export const productSlider = tv({
    extend: UIProductSlider,
    slots: {
        base: "",
        slider_navButton: [
            "tw:text-primary! tw:text-3xl!",
            "tw:focus:ring-0 tw:focus:bg-transparent tw:hover:bg-transparent!"
        ],
        slider_slides_swiperslide: ""
    },
    variants: {
        isRecent: {
            true: {
                base: "tw:bg-grey tw:p-6"
            }
        },
        type: {
            left: {
                slider_navButton: "tw:pl-0!"
            },
            right: {
                slider_navButton: "tw:pr-0!"
            }
        },
        skeleton: {
            true: {
                slider_slides_swiperslide: "tw:rounded-md"
            }
        }
    }
});
